export { getWCPledgeTeamFlagUrl } from './WCPledgeUtils';
